// General
import PropTypes from 'prop-types';
import React, { Component } from 'react';

// Redux Form
import { Field, reduxForm } from 'redux-form';

// Redux
import { connect } from 'react-redux';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';

// Locale
import messages from '../../locale/messages';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';

// Component
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import updateStep3 from './updateStep3';
import validateStep3 from './validateStep3';
import stepListIllustration from '/public/SiteImages/step-list.svg';

//Image

class Booking extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any
  };

  render() {
    const { handleSubmit, nextPage, formPage, step, isDisabled, formErrors, previousPage } = this.props;
    const { formatMessage } = this.props.intl;
    if (formErrors != undefined && formErrors.hasOwnProperty('syncErrors')) {
      isDisabled = true;
    }


    return (
      <div className={s.eslipinBg}>
        <div className={cx(s.grid, 'customRatioButton')}>
          <SidePanel
            badge="Información del alojamiento"
            highlightText={`Los toques finales \n para tener listo tu \n espacio`}
            iconImg={stepListIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={s.stepRightCard}>
              <div className={s.landingMainContent}>

                <p className={s.amenitiesSpacesTitle}><FormattedMessage {...messages.bookingTitle} /></p>
                <p className={s.bookingSpacesLabel}><FormattedMessage {...messages.bookingSubTitle} /></p>

                <div className={s.spaceTop3}>
                  <p className={cx(s.landingContentTitle, s.space3)}><FormattedMessage {...messages.whoCanBook} /></p>
                  {/* <div className={s.tipCommonCss}>
                    <img src={toolTipIcon} />
                    <span className={cx(s.commonTipCsss)}> <FormattedMessage {...messages.whoCanBookInfo} /></span>
                  </div> */}
                  <span className={cx(s.landingStep)}>

                  </span>
                </div>

                <div className={s.spaceTop3}>
                  <label className={s.displayTable}>
                    <span className={s.displayTableRow}>
                      <span className={s.displayTableCellTop}>
                        <Field name="bookingType" component="input" type="radio" value="instant" className={s.BookingradioInput} />
                      </span>
                      <span className={s.displayTableCell}>
                        <span className={cx(s.bookText, 'rtlBookText')}><FormattedMessage {...messages.whoCanBookInfo1} /></span>
                        <span className={cx(s.bookingCanBook)}><FormattedMessage {...messages.whoCanBookInfo2} /></span>
                      </span>
                    </span>
                  </label>
                </div>
                <div className={cx(s.space6, s.spaceTop3)}>
                  <label className={s.displayTable}>
                    <span className={s.displayTableRow}>
                      <span className={s.displayTableCellTop}>
                        <Field name="bookingType" component="input" type="radio" value="request" className={s.BookingradioInput} />
                      </span>
                      <span className={s.displayTableCell}>
                        <span className={cx(s.bookText, 'rtlBookText')}><FormattedMessage {...messages.whoCanBookInfo3} /></span>
                      </span>
                    </span>
                  </label>
                </div>
              </div>
              <FooterButton
                isDisabled={isDisabled}
                nextPage={nextPage}
                previousPage={previousPage}
                previousPagePath={"calendar"}
                type={"submit"}
                nextPagePath={"complete"}
                formPage={formPage}
                step={step}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

Booking = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(Booking);

const mapState = (state) => ({
  listingFields: state.listingFields.data
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Booking)));
